import { Module } from 'vuex'
import { RootState, Collection } from '../store-types'
import { MetaPayload } from '@/core/utils/pagination'
import { useMainGoalHttp } from '@/core/api/main-goals'
import { UserMainGoal, UserMainGoalPayload } from '@/core/models/user-main-goal'

export type MainGoalCollection = {
    data: Array<UserMainGoal>,
    meta?: MetaPayload,
    links?: any
}

const state: MainGoalCollection = {
    data: <any>[],
    meta: <any>[],
    links: <any>[],
}

export const mainGoalCollection: Module<MainGoalCollection, RootState> = {
    namespaced: true,
    state,
    mutations: {
        set: (state: MainGoalCollection, payload: Collection) => {
            state.data = <any>[]
            payload.data.forEach((item: UserMainGoalPayload) => {
                state.data.push(new UserMainGoal(item))
            })
            state.meta = payload.meta
            state.links = payload.links
        },
        remove: (state: MainGoalCollection, id: number) => {
            state.data = state.data.filter(item => item.id !== id)
        },
    },
    actions: {
        get: <T>(context: any, params?: any): Promise<T> => {
            return new Promise<T>((resolve, reject) => {
                useMainGoalHttp()
                    .get(params || {})
                    .then((data: any) => {
                        context.commit('set', data)
                        resolve(data as T)
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        },
        delete: <T>(context: any, id: number): Promise<T> => {
            return new Promise<T>((resolve, reject) => {
                useMainGoalHttp()
                    .del(id)
                    .then((data: any) => {
                        context.commit('remove', id)
                        resolve(data as T)
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        },
    },
    getters: {
        get: (state: MainGoalCollection): MainGoalCollection => {
            return state
        }
    }
}
